import React from "react";
import { Mark, Text } from "@mantine/core"
import { highlighter } from "./highlighter";

const HighlightOpacity = 0.5

const hexToRgb = (hex) => {
    hex = hex.replace(/^#/, "");
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `${r}, ${g}, ${b}`;
};

export const CustomHighlight = ({ text, highlight }) => {
    const highlightChunks = highlighter(text, highlight);

    const wrapWithMultipleSpans = (chunkText: string, colors: string[], i: number) => {
        return colors.reduceRight<any>((acc, color, idx) => {
            return (
                idx === (colors.length - 1) ?
                    <span key={`${i}-${idx}`} style={{ backgroundColor: `rgba(${hexToRgb(color)}, ${HighlightOpacity})` }}> {acc} </span> :
                    <span key={`${i}-${idx}`} style={{ backgroundColor: `rgba(${hexToRgb(color)}, ${HighlightOpacity})` }}>
                        {acc}
                    </span>
            );
        }, chunkText);
    };

    return (
        <Text>
            {highlightChunks.map(({ chunk, highlighted, colors }, i) =>
                highlighted ? (
                    wrapWithMultipleSpans(chunk, colors, i)
                ) : (
                    <span key={i}>
                    {chunk}
                    </span>
                )
            )}
        </Text>
    );
};

export default CustomHighlight;